import clsx from 'clsx';
import React from 'react';

const Tag = ({ rarity, theme, heading, label, children, className }) => {
  const rarityKey = rarity?.replace(' ', '');
  
  // Theme styles map
  const themeStyles = {
    // Rarity based themes
    'ultra-rare': 'text-yellow-900 bg-gradient-to-r from-yellow-300 to-amber-300 border border-yellow-500 shadow-sm shadow-yellow-400/30 font-bold',
    'rare': 'text-indigo-900 bg-gradient-to-r from-blue-300 to-indigo-300 border border-blue-500 shadow-sm',
    'uncommon': 'text-emerald-900 bg-gradient-to-r from-teal-200 to-emerald-200 border border-emerald-400',
    'gray': 'text-gray-300 bg-gray-800 border border-gray-700',
    'primary': 'text-primary-900 bg-primary-200 border border-primary-400',
    // Legacy rarity support
    Common: 'text-gray-800 bg-gray-100 border border-gray-300',
    Uncommon: 'text-green-800 bg-green-100 border border-green-300',
    Rare: 'text-blue-800 bg-blue-100 border border-blue-300',
    UltraRare: 'text-yellow-800 bg-yellow-100 border border-yellow-300 font-bold',
    Legendary: 'text-purple-800 bg-purple-100 border border-purple-300 font-bold',
  };
  
  // Calculate which style to use - prioritize theme over rarity
  const styleClass = theme ? themeStyles[theme] : (rarityKey ? themeStyles[rarityKey] : themeStyles['gray']);

  return (
    <span className={clsx(
      'inline-flex rounded-md px-2 py-0.5 text-xs font-medium flex-col justify-center transition-all duration-200',
      styleClass,
      className
    )}>
      {heading && <span className='text-[10px] font-medium opacity-75 whitespace-nowrap'>{heading}</span>}
      {rarity || label || children}
    </span>
  );
};

export default Tag;
